(function () {
  'use strict';

  try {
    // ======================= CONFIGURAÇÃO =======================
    var GIFT_THRESHOLD_CENTS = 100000; // R$ 1000,00 (valores do Shopify são sempre em centavos)
    var GIFT_VARIANT_ID = 53597197664563; // ID da variante do produto "brinde"

    // Sections do carrinho no tema Warehouse: 'mini-cart' é o drawer (aparece em
    // qualquer página) e 'main-cart' é a página /cart inteira. Manter os dois é
    // seguro: o script só atualiza a section cujo elemento existir na página
    // atual e ignora a outra silenciosamente.
    var CART_SECTIONS = ['mini-cart', 'main-cart'];
    var RELOAD_FALLBACK = true; // recarrega a página se não conseguir atualizar as sections acima
    var POLL_INTERVAL_MS = 1500; // intervalo de verificação do carrinho
    var MAX_FALHAS_SEGUIDAS = 3; // depois de N falhas seguidas, para de tentar por um tempo
    var PAUSA_APOS_FALHAS_MS = 60000; // pausa de 60s antes de tentar de novo
    var JANELA_RECONCILIACAO_MS = 8000; // depois de add/remove, insiste em reafirmar a tela por até 8s
    // ==============================================================

    var syncing = false;
    var pollTimer = null;
    var falhasSeguidas = 0;
    var emPausaPorFalha = false;
    var ultimaMudancaEm = 0; // timestamp da última vez que adicionamos/removemos o brinde

    function getCart() {
      return fetch('/cart.js', {
        headers: { 'Content-Type': 'application/json' },
        cache: 'no-store'
      }).then(function (r) { return r.json(); });
    }

    // Retorna o item do brinde no carrinho (ou null). Precisamos do item
    // inteiro (não só um boolean) porque a remoção via /cart/change.js
    // exige a "key" da linha (formato "variantId:hashDasPropriedades"),
    // e não o variant ID puro — o brinde tem a propriedade customizada
    // "_brinde_automatico", e o Shopify recusa (HTTP 400) tentar mudar a
    // quantidade de uma linha com propriedades usando só o variant ID.
    function encontrarItemBrinde(cart) {
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].variant_id === GIFT_VARIANT_ID) {
          return cart.items[i];
        }
      }
      return null;
    }

    function hasGift(cart) {
      return !!encontrarItemBrinde(cart);
    }

    function subtotalSemBrinde(cart) {
      return cart.items.reduce(function (sum, item) {
        return item.variant_id === GIFT_VARIANT_ID ? sum : sum + item.line_price;
      }, 0);
    }

    function addGift() {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: GIFT_VARIANT_ID,
            quantity: 1,
            properties: { '_brinde_automatico': 'sim' } // "_" no início esconde a propriedade do cliente
          }],
          sections: CART_SECTIONS,
          sections_url: window.location.pathname
        })
      }).then(verificarResposta);
    }

    function removeGift(itemKey) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: itemKey, // key da linha (variantId:hash), NÃO o variant ID puro — ver encontrarItemBrinde()
          quantity: 0,
          sections: CART_SECTIONS,
          sections_url: window.location.pathname
        })
      }).then(verificarResposta);
    }

    // Só considera sucesso se o Shopify respondeu com status HTTP ok.
    // Se não for, joga um Error com a mensagem real do Shopify (ex: "não há
    // estoque suficiente", "variante não encontrada") pra cair no .catch do
    // sync() e SÓ logar no console — nunca tentar recarregar a página.
    function verificarResposta(r) {
      return r.json().then(function (data) {
        if (!r.ok) {
          var msg = (data && (data.description || data.message)) || ('HTTP ' + r.status);
          throw new Error('Shopify recusou a operação no carrinho: ' + msg);
        }
        return data;
      });
    }

    // Trava anti-loop: garante que a página só recarrega no máximo 1x a
    // cada 8 segundos, mesmo que o gatilho de "recarregar" seja disparado
    // repetidamente (evita loop infinito de reload).
    function podeRecarregar() {
      try {
        var ultimo = sessionStorage.getItem('brinde_last_reload');
        if (!ultimo) return true;
        return (Date.now() - parseInt(ultimo, 10)) > 8000;
      } catch (e) {
        return true;
      }
    }

    function marcarReload() {
      try { sessionStorage.setItem('brinde_last_reload', String(Date.now())); } catch (e) {}
    }

    function aplicarSections(mapaSections) {
      if (!mapaSections) return false;

      var atualizouAlgo = false;
      CART_SECTIONS.forEach(function (sectionId) {
        var html = mapaSections[sectionId];
        if (!html) return;

        var temp = document.createElement('div');
        temp.innerHTML = html;
        var novoConteudo = temp.firstElementChild;

        // Shopify sempre envolve a section renderizada em uma div
        // #shopify-section-{id}, então esse seletor funciona em qualquer tema.
        var alvo = document.getElementById(sectionId)
          || document.querySelector('#shopify-section-' + sectionId)
          || document.querySelector('[data-section-id="' + sectionId + '"]');

        if (alvo && novoConteudo) {
          alvo.innerHTML = novoConteudo.innerHTML;
          atualizouAlgo = true;
        }
      });

      return atualizouAlgo;
    }

    // Busca o HTML das sections refletindo o estado REAL e atual do
    // carrinho (sem alterar nada) e reaplica na tela. Isso corrige casos em
    // que outra ação do tema (ex: cliente mudando a quantidade de outro
    // item ao mesmo tempo) sobrescreveu nossa atualização com uma versão
    // desatualizada por causa de uma corrida entre as duas requisições.
    function reconciliarSectionsComCarrinhoReal() {
      var separador = window.location.search ? '&' : '?';
      var url = window.location.pathname + window.location.search + separador + 'sections=' + CART_SECTIONS.join(',');

      fetch(url, { cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (mapaSections) {
          var atualizouAlgo = aplicarSections(mapaSections);
          if (!atualizouAlgo) {
            console.warn('[Brinde automático] reconciliação não encontrou nenhuma section pra atualizar (' + CART_SECTIONS.join(', ') + ') — verifique se elas existem na URL atual: ' + url);
          }
        })
        .catch(function (err) {
          console.warn('[Brinde automático] falha ao reconciliar sections:', err);
        });
    }

    function atualizarSectionsNaTela(resposta) {
      var atualizouAlgo = resposta && resposta.sections ? aplicarSections(resposta.sections) : false;

      if (!atualizouAlgo) {
        if (RELOAD_FALLBACK && podeRecarregar()) {
          marcarReload();
          window.location.reload();
          return;
        }
        console.warn('[Brinde automático] nenhuma section encontrada pra atualizar (' + CART_SECTIONS.join(', ') + ')');
      }

      // Reconcilia um pouco depois, pra corrigir qualquer condição de
      // corrida com outra atualização do carrinho feita pelo tema quase
      // ao mesmo tempo.
      setTimeout(reconciliarSectionsComCarrinhoReal, 700);
    }

    function sync() {
      if (syncing || emPausaPorFalha) return;
      syncing = true;

      getCart().then(function (cart) {
        var subtotal = subtotalSemBrinde(cart);
        var jaTemBrinde = hasGift(cart);

        if (subtotal >= GIFT_THRESHOLD_CENTS && !jaTemBrinde) {
          ultimaMudancaEm = Date.now();
          return addGift().then(atualizarSectionsNaTela);
        }
        if (subtotal < GIFT_THRESHOLD_CENTS && jaTemBrinde) {
          var itemBrinde = encontrarItemBrinde(cart);
          ultimaMudancaEm = Date.now();
          return removeGift(itemBrinde.key).then(atualizarSectionsNaTela);
        }

        // Não há nada pra adicionar/remover neste ciclo — o carrinho (fonte
        // da verdade) já está no estado correto. Mas se tivemos uma
        // alteração recente (nos últimos 8s), é possível que o próprio tema
        // tenha, ao mesmo tempo, feito sua própria requisição de carrinho
        // (ex: cliente mudando a quantidade de outro item) e a resposta
        // dela tenha chegado DEPOIS da nossa, sobrescrevendo a tela com uma
        // versão desatualizada (com o brinde que já foi removido, ou sem o
        // brinde que já foi adicionado). Continuamos reforçando a tela com
        // o HTML real por um tempo pra garantir que a versão certa vença
        // essa corrida, mesmo sem precisar adicionar/remover nada de novo.
        if (ultimaMudancaEm && (Date.now() - ultimaMudancaEm) < JANELA_RECONCILIACAO_MS) {
          reconciliarSectionsComCarrinhoReal();
        }
      }).then(function () {
        // Chegou até aqui sem cair no catch: zera o contador de falhas.
        falhasSeguidas = 0;
      }).catch(function (err) {
        console.error('[Brinde automático] erro ao sincronizar carrinho:', err);
        falhasSeguidas += 1;

        if (falhasSeguidas >= MAX_FALHAS_SEGUIDAS) {
          emPausaPorFalha = true;
          stopPolling();
          console.warn(
            '[Brinde automático] ' + falhasSeguidas + ' falhas seguidas — ' +
            'pausando por ' + (PAUSA_APOS_FALHAS_MS / 1000) + 's pra não sobrecarregar a API do Shopify. ' +
            'Verifique o GIFT_VARIANT_ID e se o produto está publicado corretamente.'
          );
          setTimeout(function () {
            falhasSeguidas = 0;
            emPausaPorFalha = false;
            startPolling();
          }, PAUSA_APOS_FALHAS_MS);
        }
      }).finally(function () {
        syncing = false;
      });
    }

    function startPolling() {
      if (pollTimer) return;
      pollTimer = setInterval(sync, POLL_INTERVAL_MS);
    }

    function stopPolling() {
      if (pollTimer) {
        clearInterval(pollTimer);
        pollTimer = null;
      }
    }

    // Pausa o polling quando a aba está em segundo plano, pra não gastar
    // requisições à toa; retoma (com checagem imediata) quando volta ao foco.
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stopPolling();
      } else {
        sync();
        startPolling();
      }
    });

    function iniciar() {
      sync();
      startPolling();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciar);
    } else {
      iniciar();
    }
  } catch (erroFatal) {
    // Qualquer erro inesperado fica isolado aqui dentro e nunca escapa
    // pra quebrar o resto da página.
    console.error('[Brinde automático] erro fatal:', erroFatal);
  }
})();